import { useState } from 'react'

import CheckoutContainer from '@components/CheckoutContainer'
import PaymentMethodButton from '@components/PaymentMethodButton'

import { PaymentMethods } from 'mmfintech-checkout-commons'

const TestMethods = () => {
  const [selected, setSelected] = useState<string>(null)

  return (
    <CheckoutContainer>
      <div className='payment-container'>
        <h2>Testing method names and logos</h2>

        {Object.keys(PaymentMethods)
          .sort()
          .map(name => {
            return (
              <PaymentMethodButton
                key={name}
                name={name}
                disabled={false}
                selected={selected === name}
                onClick={() => {
                  setSelected(name)
                }}
                onContinue={() => {
                  setSelected(null)
                }}
                skipDoubleClickPrevention={true}
              />
            )
          })}
      </div>
    </CheckoutContainer>
  )
}

export default TestMethods
